<template>
    <b-row>
        <table class="table table-sm table-hover">
            <thead class="thead-dark">
            <tr>
                <th scope="col">Account</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th scope="row">Account</th>
                <td>{{ client.client_id }}</td>
            </tr>
            <tr>
                <th scope="row">Name</th>
                <td>{{ client.user.get_full_name }}</td>
            </tr>
            <tr>
                <th scope="row">Base Currency</th>
                <td>{{ client.fund.base_currency }}</td>
            </tr>
            <tr>
                <th scope="row">First Deposit</th>
                <td>{{ client.first_deposit }}</td>
            </tr>
            <tr>
                <th scope="row">Total deposit count</th>
                <td>??</td>
            </tr>
            </tbody>
            <thead class="thead-dark">
            <tr>
                <th scope="col">Overview</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th scope="row">Shares</th>
                <td>{{ client.current_shares }}</td>
                <td>shares</td>
            </tr>
            <tr>
                <th scope="row">Total Deposits</th>
                <td>{{ client.deposits }}</td>
                <td>{{ client.fund.base_currency }}</td>
            </tr>
            <tr>
                <th scope="row">Assets to {{new Date().getFullYear() }}</th>
                <td>{{ assets }}</td>
                <td>{{ client.fund.base_currency }}</td>

            </tr>
            <tr>
                <th scope="row">High-Water Mark</th>
                <td>??</td>
                <td>{{ client.fund.base_currency }}</td>

            </tr>
            <tr></tr>
            <tr>
                <th scope="row">Result</th>
                <td>{{ result }}</td>
                <td>{{ client.fund.base_currency }}</td>
            </tr>
            <tr>
                <th scope="row"></th>
                <td>{{ result_percent.toFixed(3) }}</td>
                <td>%</td>
            </tr>
            </tbody>
        </table>

    </b-row>

</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';

    @Component({
        computed: {
            result() {
                return this.$store.state.user_data.user_data['result']
            },
            result_percent() {
                return this.$store.state.user_data.user_data['result_percent']
            },
            client() {
                return this.$store.state.user_data.user_data['client']
            },
            assets() {
                return this.$store.state.user_data.user_data['assets']
            },
        }
    })
    export default class UserData extends Vue {
    }

</script>

<style scoped>

</style>